/* eslint-disable react/prop-types */
import _get from 'lodash.get';
import React from 'react';
//import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';

// eslint-disable-next-line import/prefer-default-export
export function getUrlFromactiveSubsection(sectionData) {
  if (sectionData.subSections instanceof Array) {
    return _get(
      sectionData.subSections.filter(item => item.active)[0],
      'link',
      sectionData.link,
    );
  }
  return sectionData.link || sectionData.path;
}
// eslint-disable-next-line react/prop-types
export function LazyLoadga({
  //labelText,
  //sectionName,
  onSeenCallback,
  id,
  //gaAction,
  //gaLabel,
  hideGA,
  //gaCategory,
}) {
  return (
    <div style={{ display: hideGA ? 'none' : 'block' }}>
      <InViewObserver
        inViewCallback={() => {
          // sendGaThroughProps({
          //   data: {
          //     gaAction: gaAction || 'scroll_measure',
          //     gaLabel: gaLabel || `Scroll_${sectionName}${labelText}`,
          //     gaCategory,
          //     nonInteraction: true,
          //   },
          // });

          if (typeof onSeenCallback === 'function' && id) {
            onSeenCallback(id);
          }
        }}
        height="1px"
      >
        <div />
      </InViewObserver>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function LazyLoadGaHOC({
  children,
  index,
  sectionItem,
  onSeenCallback,
  hideGA,
  id,
  gaAction,
  gaLabel,
  gaCategory,
  ga4Type,
}) {
  return (
    <React.Fragment>
      {index > 0 && (
        <LazyLoadga
          sectionName={sectionItem.name}
          labelText="Starts"
          onSeenCallback={onSeenCallback}
          id={id}
          gaAction={gaAction}
          gaLabel={gaLabel}
          hideGA={hideGA}
          gaCategory={gaCategory}
          ga4Type={ga4Type}
        />
      )}
      {children}
      {index === 0 && (
        <LazyLoadga
          sectionName={sectionItem.name}
          labelText="Ends"
          onSeenCallback={onSeenCallback}
          id={id}
          gaAction={gaAction}
          gaLabel={gaLabel}
          hideGA={hideGA}
          gaCategory={gaCategory}
          ga4Type={ga4Type}
        />
      )}
    </React.Fragment>
  );
}
